export {default as voronoi} from "./src/voronoi";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-voronoi/index.js
// module id = ../../../../d3-voronoi/index.js
// module chunks = 4